module.exports = __webpack_public_path__ + "static/media/moon.dc75df84.svg";